import { render, staticRenderFns } from "./AnnouncementsPopover.vue?vue&type=template&id=0b2a317e&scoped=true&"
import script from "./AnnouncementsPopover.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsPopover.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsPopover.vue?vue&type=style&index=0&id=0b2a317e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a317e",
  null
  
)

export default component.exports